import { render, staticRenderFns } from "./AppleLoginComponent.vue?vue&type=template&id=4b52397c&scoped=true&"
import script from "./AppleLoginComponent.vue?vue&type=script&lang=js&"
export * from "./AppleLoginComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b52397c",
  null
  
)

export default component.exports